import React from "react";
import Modal from "../modal/Modal";
import css from "./NewsletterPopup.module.scss";

const NewsletterPopup = ({ open, onClose }) => {
  return (
    <Modal
      visible={open}
      onHide={onClose}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      customClass={css.popup}
      customOverlay={css.overlay}
    >
      <div className={css.content}>
        <h3 className={css.title}>Join our newsletter</h3>
        <p className={css.subtitle}>
          Get updates about new publications and offers.
        </p>
        <button type="button" className={css.cta} onClick={onClose}>
          Close
        </button>
      </div>
    </Modal>
  );
};

export default NewsletterPopup;
